export enum Timezone {
    Amsterdam = 'Europe/Amsterdam',
    UTC = 'UTC',
}
